import { SESSION_TEST_IDS } from './contracts';

/**
 * The dead link (§5.1) - revoked, expired, unknown, or with nothing left that
 * resolves.
 *
 * It takes NO props, and that is the requirement rather than an economy: the
 * four cases render the SAME screen, so this component must have nothing to
 * tell them apart with. A prop naming which one it is would be a probe -
 * somebody sounding out secrets would learn which exist - and it would
 * eventually be rendered. The régime of `chat/expired.tsx`, and the same
 * consequence: it offers NO retry, because there is nothing to retry.
 *
 * The wording says the RULE and not the verdict on this secret, which is how it
 * can be true in all four cases without telling the reader which one she is in.
 */
export function SessionDeadLink() {
  return (
    <section
      data-testid={SESSION_TEST_IDS.dead}
      className="mx-auto flex max-w-xl flex-col gap-3 py-12"
    >
      <h1 className="font-semibold text-h3 text-bleu-nuit">Ce lien n’est plus valable</h1>
      <p className="max-w-[62ch] text-body text-gray-700">
        Les liens d’invitation ont une durée de vie, et ils peuvent être fermés avant. Demandez-en
        un nouveau à la personne qui vous a invité.
      </p>
    </section>
  );
}
